/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Recording_Show_Start_ButtonInputs */

const en_forms_teams_settings_recording_show_start_button = /** @type {(inputs: Forms_Teams_Settings_Recording_Show_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Button`)
};

const de_forms_teams_settings_recording_show_start_button = /** @type {(inputs: Forms_Teams_Settings_Recording_Show_Start_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start-Button anzeigen`)
};

/**
* | output |
* | --- |
* | "Start Button" |
*
* @param {Forms_Teams_Settings_Recording_Show_Start_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_recording_show_start_button = /** @type {((inputs?: Forms_Teams_Settings_Recording_Show_Start_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Recording_Show_Start_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_recording_show_start_button(inputs)
	return de_forms_teams_settings_recording_show_start_button(inputs)
});